// Product page functionality
// Handles product image switching, variant selection, and product-specific interactions

// --- Selectors ---
const productSelectors = {
  productForm: "#product-form-ajax",
  variantSelect: "#variant-select",
  productPriceDisplay: "#product-price",
  addToCartButton: "button[type='submit']",
  addToCartText: "#add-to-cart-text",
  mainProductImage: "#main-product-image",
  productThumbs: ".product-thumb",
  variantOptionInputs: ".variant-option-input",
  quantityInput: "#quantity"
};

// --- Product Functions ---

/**
 * Updates the main product image
 * @param {string} imageSrc - New image source URL
 * @param {string} altText - Alt text for the image
 */
function updateMainImage(imageSrc, altText) {
  console.log('Product: Updating main image to:', imageSrc);

  const mainImageContainer = document.querySelector(productSelectors.mainProductImage);
  const mainImage = mainImageContainer ? mainImageContainer.querySelector('img') : null;

  if (mainImage) {
    mainImage.src = imageSrc;
    mainImage.alt = altText;

    // Update active thumbnail
    document.querySelectorAll(productSelectors.productThumbs).forEach(thumb => {
      thumb.classList.remove('border-pink-600');
      const thumbImg = thumb.querySelector('img');
      if (thumbImg && thumbImg.src.includes(imageSrc.split('/').pop())) {
        thumb.classList.add('border-pink-600');
      }
    });

    console.log('Product: Main image updated successfully');
  } else {
    console.error('Product: Main image element not found');
  }
}

/**
 * Updates the UI based on the currently selected variant
 * @param {Element} selectedVariant - The selected variant option
 */
function updateProductUI(selectedVariant) {
  console.log('Product: Updating UI for variant:', selectedVariant);

  const productPriceDisplay = document.querySelector(productSelectors.productPriceDisplay);
  const addToCartButton = document.querySelector(productSelectors.productForm + ' ' + productSelectors.addToCartButton);
  const addToCartText = document.querySelector(productSelectors.addToCartText);

  if (selectedVariant && productPriceDisplay) {
    // Update Price
    const price = selectedVariant.dataset.price;
    if (price) {
      productPriceDisplay.textContent = price;
    }

    // Update Add to Cart Button State
    if (selectedVariant.disabled || selectedVariant.dataset.available === 'false') {
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }
      if (addToCartText) {
        addToCartText.textContent = "Sold Out";
      }
    } else {
      if (addToCartButton) {
        addToCartButton.disabled = false;
      }
      if (addToCartText) {
        addToCartText.textContent = "Add to Cart (AJAX)";
      }
    }

    console.log('Product: UI updated for variant');
  } else {
    console.log('Product: No valid variant selected');
  }
}

/**
 * Handles changes to the custom radio buttons/swatches and links them to the hidden select
 */
function handleVariantOptionChange() {
  console.log('Product: Variant option changed');

  // Collect current selections from radio buttons
  const selections = {};
  document.querySelectorAll(productSelectors.variantOptionInputs + ":checked").forEach((input) => {
    const fieldset = input.closest("fieldset");
    const optionName = fieldset ? fieldset.dataset.optionName : '';
    selections[optionName] = input.value;
  });

  console.log('Product: Current selections:', selections);

  // Find the matching variant in the hidden select dropdown
  const variantSelect = document.querySelector(productSelectors.variantSelect);
  let selectedVariant = null;

  if (variantSelect) {
    // Simplified variant finding - in a real implementation you'd use Shopify's Product JSON
    selectedVariant = variantSelect.options[variantSelect.selectedIndex];
    console.log('Product: Selected variant from dropdown:', selectedVariant);
  }

  // Trigger the update
  if (selectedVariant) {
    updateProductUI(selectedVariant);
  }
}

/**
 * Handles product form submission
 * @param {Event} event - Form submit event
 */
async function handleProductFormSubmit(event) {
  event.preventDefault();
  console.log('Product: Form submitted');

  const form = event.target;
  const addToCartButton = form.querySelector(productSelectors.addToCartButton);
  const addToCartText = form.querySelector(productSelectors.addToCartText);

  // Disable button to prevent double click
  if (addToCartButton) {
    addToCartButton.disabled = true;
  }
  if (addToCartText) {
    addToCartText.textContent = "Adding...";
  }

  const formData = new FormData(form);

  // Serialize form data for AJAX submission
  const item = {
    id: formData.get("id"),
    quantity: formData.get("quantity"),
  };

  console.log('Product: Adding item to cart:', item);

  // Import cart functionality (assuming cart.js is loaded)
  if (typeof addToCart !== 'undefined') {
    const success = await addToCart(item.id, item.quantity);

    // Re-enable button after submission
    if (success) {
      if (addToCartButton) {
        addToCartButton.disabled = false;
      }
      if (addToCartText) {
        addToCartText.textContent = "Added!";
      }
    } else {
      // Handle error state
      if (addToCartButton) {
        addToCartButton.disabled = false;
      }
      if (addToCartText) {
        addToCartText.textContent = "Error Adding";
      }
    }

    // Reset text after a delay
    setTimeout(() => {
      if (addToCartText) {
        addToCartText.textContent = "Add to Cart (AJAX)";
      }
    }, 1500);
  } else {
    console.error('Product: addToCart function not available');
  }
}

/**
 * Handles thumbnail click to switch main image
 * @param {Event} event - Click event
 */
function handleThumbnailClick(event) {
  event.preventDefault();
  console.log('Product: Thumbnail clicked');

  const thumbImg = event.currentTarget.querySelector('img');
  if (thumbImg) {
    const newImageSrc = thumbImg.src.replace('width=100', 'width=800');
    const altText = thumbImg.alt;
    updateMainImage(newImageSrc, altText);
  }
}

/**
 * Loads product recommendations
 */
function loadProductRecommendations() {
  const wrapper = document.querySelector(".product-recommendations-wrapper");
  if (!wrapper) {
    console.log('Product: No product recommendations wrapper found');
    return;
  }

  console.log('Product: Loading product recommendations');

  const productId = wrapper.dataset.productId;
  const limit = wrapper.dataset.limit;
  const sectionId = wrapper.dataset.sectionId;
  const url = `${wrapper.dataset.baseUrl}?product_id=${productId}&limit=${limit}&section_id=${sectionId}`;

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const container = document.getElementById(`product-recommendations-${sectionId}`);
      if (container) {
        container.innerHTML = html;
        // Re-initialize quick add listeners for new recommendations
        initQuickAddListeners();
        console.log('Product: Recommendations loaded successfully');
      }
    })
    .catch((error) => {
      console.error("Product: Error loading product recommendations:", error);
    });
}

/**
 * Initializes Quick Add listeners
 */
function initQuickAddListeners() {
  console.log('Product: Initializing quick add listeners');

  document.querySelectorAll('[data-action="quick-add"]').forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      const variantId = button.dataset.variantId;
      const quantity = 1;
      console.log("Product: Quick add triggered for variant:", variantId);

      if (typeof addToCart !== 'undefined') {
        await addToCart(variantId, quantity);
      } else {
        console.error('Product: addToCart function not available for quick add');
      }
    });
  });
}

// --- Initialization ---

function initProduct() {
  console.log('Product: Initializing product functionality');

  // Product image switching
  document.querySelectorAll(productSelectors.productThumbs).forEach(thumb => {
    thumb.addEventListener('click', handleThumbnailClick);
  });

  // Variant selection
  document.querySelectorAll(productSelectors.variantOptionInputs).forEach(input => {
    input.addEventListener('change', handleVariantOptionChange);
  });

  // Product form submission
  const productForm = document.querySelector(productSelectors.productForm);
  if (productForm) {
    productForm.addEventListener('submit', handleProductFormSubmit);
  }

  // Load product recommendations on page load
  loadProductRecommendations();

  console.log('Product: Product initialization complete');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProduct);
} else {
  initProduct();
}

// Export functions for use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    updateMainImage,
    updateProductUI,
    handleVariantOptionChange,
    handleProductFormSubmit,
    loadProductRecommendations,
    initQuickAddListeners,
    initProduct
  };
}